module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-Light-177c53a6.eot";